import { PhotoType } from '@EcamModel/model';
import { StepConnector, stepConnectorClasses, styled } from '@mui/material';
import color from '@theme/Colors';

const stepsLabel = ['Camera Selection', 'Evidence Selection', 'Review & Create'];

const mappingLabelPhotosType = {
    [PhotoType.Entry]: 'Entry',
    [PhotoType.Validation]: 'Validation',
    [PhotoType.Exit]: 'Exit',
    [PhotoType.Overview]: 'Overview',
    [PhotoType.UnobstructedPlate]: 'Full plate',
};

const photoTypeColors: Record<PhotoType, string> = {
    [PhotoType.Entry]: color.success,
    [PhotoType.Validation]: color.colorANPR,
    [PhotoType.Exit]: color.warning,
    [PhotoType.UnobstructedPlate]: color.pink,
    [PhotoType.Overview]: color.error,
};

const photoTypeColorsLight: Record<PhotoType, string> = {
    [PhotoType.Entry]: color.success50,
    [PhotoType.Validation]: color.colorANPR50,
    [PhotoType.Exit]: color.warning50,
    [PhotoType.UnobstructedPlate]: color.pink50,
    [PhotoType.Overview]: color.error50,
};

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 2,
        border: 0,
        backgroundColor: theme.palette.grey[300],
        borderRadius: 1,
        transition: 'background-color 0.3s ease',
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
        backgroundColor: theme.palette.primary.main,
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
        backgroundColor: theme.palette.primary.main,
    },
}));

const photoTypeColorMap: Record<PhotoType, { main: string; bg: string; bgHover: string }> = {
    [PhotoType.Entry]: { main: '#4CAF50', bg: '#4CAF5033', bgHover: '#4CAF5066' },
    [PhotoType.Validation]: { main: '#FF9800', bg: '#FF980033', bgHover: '#FF980066' },
    [PhotoType.Exit]: { main: '#F44336', bg: '#F4433633', bgHover: '#F4433666' },
    [PhotoType.UnobstructedPlate]: { main: color.secondary, bg: '#007BFF33', bgHover: '#007BFF66' },
    [PhotoType.Overview]: { main: '#9C27B0', bg: '#9C27B033', bgHover: '#9C27B066' },
};

export { stepsLabel, mappingLabelPhotosType, photoTypeColors, photoTypeColorsLight, CustomStepConnector, photoTypeColorMap };
